/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S5_TitleInputs */

const en_guide_large_json_files_s5_title = /** @type {(inputs: Guide_Large_Json_Files_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategy 4: Use the Right Format`)
};

const ko_guide_large_json_files_s5_title = /** @type {(inputs: Guide_Large_Json_Files_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전략 4: 적합한 포맷 사용하기`)
};

const ja_guide_large_json_files_s5_title = /** @type {(inputs: Guide_Large_Json_Files_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戦略4：適切なフォーマットを使用する`)
};

/**
* | output |
* | --- |
* | "Strategy 4: Use the Right Format" |
*
* @param {Guide_Large_Json_Files_S5_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s5_title = /** @type {((inputs?: Guide_Large_Json_Files_S5_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S5_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s5_title(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s5_title(inputs)
	return ja_guide_large_json_files_s5_title(inputs)
});